import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Notification } from '@returnmates/client-core/src/graphql/generated/api'
import clsx from 'clsx'
import { memo } from 'react'

import useStyles from '../styles'
import NotificationTrackingRow from './NotificationTrackingRow'

interface Props {
  notificationReports: Notification[]
}

const NotificationsHistory = ({ notificationReports }: Props) => {
  const classes = useStyles()

  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.headerRow}>
          <TableCell className={classes.headerCell}>Date</TableCell>
          <TableCell className={classes.headerCell}>Status</TableCell>
          <TableCell className={clsx(classes.headerCell)}>Type</TableCell>
          <TableCell className={clsx(classes.headerCell)}>Medium</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {notificationReports?.map((notification, idx) => (
          <NotificationTrackingRow notification={notification} key={idx} />
        ))}
      </TableBody>
    </Table>
  )
}

export default memo(NotificationsHistory)
